import {
    fullGamblingCompliance as fullGamblingComplianceBet365,
    shortGamblingCompliance as shortGamblingComplianceBet365,
} from './Bet365';
import {
    fullGamblingCompliance as fullGamblingComplianceCoral,
    shortGamblingCompliance as shortGamblingComplianceCoral,
} from './Coral';
import {
    fullGamblingCompliance as fullGamblingComplianceLadbrokes,
    shortGamblingCompliance as shortGamblingComplianceLadbrokes,
} from './Ladbrokes';
import {
    fullGamblingCompliance as fullGamblingCompliancePaddyPower,
    shortGamblingCompliance as shortGamblingCompliancePaddyPower,
} from './PaddyPower';
import {
    fullGamblingCompliance as fullGamblingComplianceBetfair,
    shortGamblingCompliance as shortGamblingComplianceBetfair,
} from './Betfair';
import {
    fullGamblingCompliance as fullGamblingComplianceWilliamHill,
    shortGamblingCompliance as shortGamblingComplianceWilliamHill,
} from './WilliamHill';
import {
    fullGamblingCompliance as fullGamblingComplianceSkybet,
    shortGamblingCompliance as shortGamblingComplianceSkybet,
} from './Skybet';

const getGamblingCompliance = (feed) => {
    switch (feed) {
        case 'BET365':
            return fullGamblingComplianceBet365();
        case 'CORAL':
            return fullGamblingComplianceCoral();
        case 'LADB':
            return fullGamblingComplianceLadbrokes();
        case 'PPWR':
            return fullGamblingCompliancePaddyPower();
        case 'BETFAIR':
            return fullGamblingComplianceBetfair();
        case 'WH_OXI':
            return fullGamblingComplianceWilliamHill();
        case 'SURREY':
            return fullGamblingComplianceSkybet();
        default:
            return fullGamblingComplianceWilliamHill();
    }
}

const getShortGamblingCompliance = (feed) => {
    switch (feed) {
        case 'BET365':
            return shortGamblingComplianceBet365();
        case 'CORAL':
            return shortGamblingComplianceCoral();
        case 'LADB':
            return shortGamblingComplianceLadbrokes();
        case 'PPWR':
            return shortGamblingCompliancePaddyPower();
        case 'BETFAIR':
            return shortGamblingComplianceBetfair();
        case 'WH_OXI':
            return shortGamblingComplianceWilliamHill();
        case 'SURREY':
            return shortGamblingComplianceSkybet();
        default:
            return shortGamblingComplianceWilliamHill();
    }
}

export {
    getGamblingCompliance,
    getShortGamblingCompliance,
}



// WEBPACK FOOTER //
// /src/js/common/gamblingCompliance/index.js